// extracted by mini-css-extract-plugin
module.exports = {"submit":"ChangePassword_submit__31lF8"};